import { useCallback, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import useConnectWallet from '@/store/wallet/useConnectWallet'

/**
 * useFlowWithdraw - 赎回质押 Hook（交易类）
 * 
 * 用于调用 FlexibleStaking 合约的 withdraw 方法赎回指定的质押记录。
 * 通过 tx.wait() 等待交易确认，使用 toast 显示交易结果提示。
 * 

 * @returns {Object} 返回赎回方法和加载状态
 *   - getFlowWithdraw: 执行赎回的函数
 *   - flowWithdrawLod: 加载状态，表示交易是否正在进行中
 */
const useFlowWithdraw = (type = 0) => {
    // 加载状态
    const [flowWithdrawLod, setLoading] = useState(false)
    // 从 useConnectWallet 获取 FlexibleStaking 合约实例
    const { contractEvm: { FlexibleStaking, RegularStaking } } = useConnectWallet()
    const con = useMemo(() => [
        FlexibleStaking, RegularStaking
    ], [FlexibleStaking, RegularStaking])
    /**
     * 赎回质押函数
     * @param id - 质押记录的 ID
     */
    const getFlowWithdraw = useCallback(async (id: bigint,
        toastText: { success: string; error: string },
        successFn?: Function, errorFn?: Function
    ) => {
        if (FlexibleStaking) {
            setLoading(true)
            try {
                // 调用合约的 withdraw 方法
                const tx = await con[type]?.withdraw(id)
                // 等待交易确认
                await tx.wait()
                // 显示成功提示
                toast.success(toastText.success)
                // 成功后调用成功回调函数
                successFn && successFn();
            } catch (e) {
                console.log('useFlowWithdraw', e);
                // 显示失败提示
                toast.error(toastText.error)
                // 失败后调用失败回调函数
                errorFn && errorFn();
            } finally {
                setLoading(false)
            }
        }
    }, [FlexibleStaking, con, type])

    return { getFlowWithdraw, flowWithdrawLod }
}

export default useFlowWithdraw